import React from 'react'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const Colors = React.lazy(() => import('./views/theme/colors/Colors'))
const Typography = React.lazy(() => import('./views/theme/typography/Typography'))

// Base
const Accordion = React.lazy(() => import('./views/base/accordion/Accordion'))
const Breadcrumbs = React.lazy(() => import('./views/base/breadcrumbs/Breadcrumbs'))
const Cards = React.lazy(() => import('./views/base/cards/Cards'))
const Carousels = React.lazy(() => import('./views/base/carousels/Carousels'))
const Collapses = React.lazy(() => import('./views/base/collapses/Collapses'))
const ListGroups = React.lazy(() => import('./views/base/list-groups/ListGroups'))
const Navs = React.lazy(() => import('./views/base/navs/Navs'))
const Paginations = React.lazy(() => import('./views/base/paginations/Paginations'))
const Placeholders = React.lazy(() => import('./views/base/placeholders/Placeholders'))
const Popovers = React.lazy(() => import('./views/base/popovers/Popovers'))
const Progress = React.lazy(() => import('./views/base/progress/Progress'))
const Spinners = React.lazy(() => import('./views/base/spinners/Spinners'))
const Tables = React.lazy(() => import('./views/base/tables/Tables'))
const Tooltips = React.lazy(() => import('./views/base/tooltips/Tooltips'))

// Buttons
const Buttons = React.lazy(() => import('./views/buttons/buttons/Buttons'))
const ButtonGroups = React.lazy(() => import('./views/buttons/button-groups/ButtonGroups'))
const Dropdowns = React.lazy(() => import('./views/buttons/dropdowns/Dropdowns'))

//Forms
const ChecksRadios = React.lazy(() => import('./views/forms/checks-radios/ChecksRadios'))
const FloatingLabels = React.lazy(() => import('./views/forms/floating-labels/FloatingLabels'))
const FormControl = React.lazy(() => import('./views/forms/form-control/FormControl'))
const InputGroup = React.lazy(() => import('./views/forms/input-group/InputGroup'))
const Layout = React.lazy(() => import('./views/forms/layout/Layout'))
const Range = React.lazy(() => import('./views/forms/range/Range'))
const Select = React.lazy(() => import('./views/forms/select/Select'))
const Validation = React.lazy(() => import('./views/forms/validation/Validation'))

const Charts = React.lazy(() => import('./views/charts/Charts'))

// Icons
const CoreUIIcons = React.lazy(() => import('./views/icons/coreui-icons/CoreUIIcons'))
const Flags = React.lazy(() => import('./views/icons/flags/Flags'))
const Brands = React.lazy(() => import('./views/icons/brands/Brands'))

// Notifications
const Alerts = React.lazy(() => import('./views/notifications/alerts/Alerts'))
const Badges = React.lazy(() => import('./views/notifications/badges/Badges'))
const Modals = React.lazy(() => import('./views/notifications/modals/Modals'))
const Toasts = React.lazy(() => import('./views/notifications/toasts/Toasts'))

const Widgets = React.lazy(() => import('./views/widgets/Widgets'))

const routes = [
  // { path: '/admin', name: '관리자', exact: true },
  { path: '/admin/store/register', name: '스토어 등록', exact: true },
  { path: '/admin', name: '대시보드', exact: true },
  { path: '/admin/store/management', name: '스토어 관리', exact: true },
  { path: '/admin/store/confirmYnManagement', name: '미승인 스토어 관리', exact: true },
  { path: '/admin/product/list', name: '상품 목록', exact: true },
  { path: '/admin/product/register', name: '상품 등록', exact: true },
  { path: '/admin/productCategory', name: '카테고리 관리', exact: true },
  { path: '/admin/brand/register', name: '브랜드 등록', exact: true },
  { path: '/admin/brand/list', name: '브랜드 목록', exact: true },
  { path: '/admin/category/create', name: '카테고리 등록', exact: true },
  { path: '/admin/category/register', name: '카테고리 관리', exact: true },
  { path: '/admin/vendor/orderRequests', name: '발주요청내역', exact: true },
  { path: '/admin/vendor/autoOrdering', name: '자동발주내역', exact: true },
  { path: '/admin/vendor/list', name: '점주목록', exact: true },
  { path: '/admin/vendor/inquire/list', name: '문의목록', exact: true },
  { path: '/admin/vendor/register', name: '점주등록', exact: true },
  { path: '/admin/vending/register', name: '기기등록', exact: true },
  { path: '/admin/vending/mapping', name: '기기매핑', exact: true },
  { path: '/admin/iot/home', name: 'IoT관리', exact: true },
  { path: '/admin/cctv/home', name: 'CCTV 현황', exact: true },
  { path: '/admin/verificationStats', name: '성인인증통계', exact: true },
  { path: '/admin/vendor/salesRate', name: '파트너 판매율 관리', exact: true },
  { path: '/admin/settlement', name: '정산 관리', exact: true },
  { path: '/admin/detailedSettlement', name: '상세 정산 관리', exact: true },
  //파트너
  { path: '/partners', name: '홈', exact: true },
  { path: '/partners/store/register', name: '스토어 등록', exact: true },
  { path: '/partners/store/management', name: '스토어 관리', exact: true },
  { path: '/partners/store/settlement', name: '정산 관리', exact: true },
  { path: '/partners/store/salesStatistics', name: '매출 통계', exact: true },
  { path: '/partners/product/list', name: '상품 목록', exact: true },
  { path: '/partners/product/register', name: '상품 등록', exact: true },
  { path: '/partners/brand/register', name: '브랜드 등록', exact: true },
  { path: '/partners/brand/list', name: '브랜드 관리', exact: true },
  { path: '/partners/vending/register', name: '기기등록', exact: true },
  { path: '/partners/vending/mapping', name: '기기매핑', exact: true },

]

export default routes
